<template>
  <Modal
    class="scoped"
    hide-close-button
    :modal-style="modalStyle"
    offset-menu
    :title="
      $t('modals.confirm_remove_bookmark_stream_modal.remove_shared_stream', {
        streamTypeLabel,
      })
    "
  >
    <p>
      {{
        $t("modals.confirm_remove_bookmark_stream_modal.line_1", {
          streamTypeLabel,
        })
      }}
    </p>
    <i18n-t
      keypath="modals.confirm_remove_bookmark_stream_modal.line_2"
      :plural="stream.users.length - 1"
      scope="global"
      tag="p"
    >
      <template #streamTypeLabel>
        {{ streamTypeLabel }}
      </template>

      <template #usersCount>
        <strong>
          {{ stream.users.length - 1 }}
        </strong>
      </template>
    </i18n-t>

    <template #buttons>
      <BaseButton
        :aria-label="$t('global.cancel')"
        flat
        :label="$t('global.cancel')"
        new-design
        @click="cancel"
      />
      <BaseButton
        :aria-label="$t('global.confirm')"
        color="danger"
        :label="$t('global.confirm')"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "ConfirmRemoveBookmarkStreamModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    stream: {
      type: Object,
      required: true,
    },
    streamTypeLabel: {
      type: String,
      required: true,
    },
  },
  emits: ["confirm", "cancel"],
  computed: {
    modalStyle() {
      return { width: this.$isDesktop ? "40%" : "100%" };
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
      this.close();
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    },
    close() {
      this.$modals.close("ConfirmRemoveBookmarkStreamModal");
    },
  },
};
</script>
